import React, { useContext, useEffect } from "react";

import { PrivateContext } from "lib/context";
import { Spinner } from "lib/components";
import { withErrorBoundary } from "lib/hoc";
import { useNavigate } from "react-router-dom";

const BillingFailure = () => {
  const { currentUserRefetch } = useContext(PrivateContext);
  const navigate = useNavigate();

  useEffect(() => {
    currentUserRefetch();
    navigate("/");
  }, []);

  return <Spinner isFullPage />;
};

export default withErrorBoundary(BillingFailure);
